import Axios from "axios";

export class AccionistaService {

    getAccionista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/accionista/lista?${queryParams}`).then(res => res.data);
    }

    newAccionista(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/accionista/nuevo`, data).then(res => res.data);
    }

    editarAccionista(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/accionista/editar`, data).then(res => res.data);
    }

    consultarAccionista(id, seccion, params = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/accionista/consulta/${id}/${seccion}`, { params }).then(res => res.data);
    }

    eliminarAccionista(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/accionista/eliminar/${id}`).then(res => res.data);
    }
    descargar(id, params = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/accionista/reporte/${id}`, 
            { headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob', params })
            .then(async res => res.data);
    }
}